(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReservationTravelPricing',
	};

	var old_commission            = null,
		$first_air_component      = null,
		commission_change_timeout;

	var _applyCoupon,
	    _calculateCommission,
	    _calculatePercentage,
	    _copyPricingColumn,
	    _copyPricingRow,
	    _fixFloat,
	    _formatTotal,
	    _getCommissionField,
	    _getCommissionableField,
	    _showCommissionChange,
	    _toggleCommissionField,
	    _toggleComponent,
	    _updateCalculator,
	    _updateRadioAlerts,
	    _updateTotals;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$('.tp-expand-collapse').on('click', function click(e) {
			var $a = $(this);

			e.preventDefault();

			$('.tp-component-header').each(function iterator(i, header) {
				_toggleComponent($(header), $a.data('action'));
			});
		});

		$('#cc-close-button').on('click', function click(e) {
			$('.commission_calculator').addClass('hidden');
			$('.tp-conditionally-commissionable').addClass('hidden');
		});

		$('#cc-calculate-button').on('click', function click(e) {
			var $input = $('.commission_calculator').data('current-input'),
			    price  = _fixFloat($input.val());

			if ($input.data('price-row') === 'price') {
				price = _applyCoupon($input);
			}

			$('#cc-new-commission').val(accounting.formatNumber((price * (_fixFloat($('#cc-commission-percentage').val()) / 100)), 2, ''));

			$('#cc-new-commission').prop('disabled', false);
			$('#cc-accept-button').prop('disabled', false);
		});

		$('#cc-accept-button').on('click', function click(e) {
			var $input = $('.commission_calculator').data('current-input'),
			    price  = _fixFloat($input.val());

			if ($input.data('price-row') === 'price') {
				price = _applyCoupon($input);
			}

			$input.data('commission-percentage', _calculatePercentage(price, $('#cc-new-commission').val()));

			_calculateCommission($input);
			_copyPricingRow($input);

			$('.commission_calculator').addClass('hidden');
			$('.tp-conditionally-commissionable').addClass('hidden');

			_updateTotals();
		});

		$('.tp-pricing-display-type').on('change', function change (e) {
			var $radio          = $(this),
			    $component      = $('#' + $radio.data('component-key')),
			    $air_components;

			if ($radio.val() === 'detailed') {
				$component.find('.tp-sp-column-header').addClass('hidden');
				$component.find('.tp-column-header').removeClass('hidden');

				$component.find('.tp-simple-pricing').addClass('hidden');
				$component.find('.tp-sp-includes-air').addClass('hidden');
				$component.find('.tp-sp-total-air-price').addClass('hidden');
				$component.find('.tp-sp-air-commission-rate').addClass('hidden');
				$component.find('.tp-detailed-pricing').removeClass('hidden');

				$('.tp-expand-collapse-div').removeClass('hidden');
				$('.tp-component-header').removeClass('hidden');

				if ($first_air_component !== null && $('.tp-sp-includes-air-button:checked').val() === '1') {
					_toggleComponent($first_air_component.find('.tp-component-header'), 'expand');
				}
			} else {
				$('.tp-component-header').each(function iterator(i, header) {
					_toggleComponent($(header), 'collapse');
				});

				$('.tp-component-header').addClass('hidden');
				$('.tp-expand-collapse-div').addClass('hidden');
				$('.commission_calculator').addClass('hidden');

				$component.find('.tp-column-header').addClass('hidden');
				$component.find('.tp-sp-column-header').removeClass('hidden');

				$component.find('.tp-detailed-pricing').addClass('hidden');

				$air_components = $('[id*="air-"]');

				if ($air_components.length > 0) {
					$component.find('.tp-sp-includes-air').removeClass('hidden');

					if ($component.find('.tp-sp-includes-air-button:checked').val() === '1') {
						$component.find('.tp-sp-total-air-price').removeClass('hidden');
						$component.find('.tp-sp-air-commission-rate').removeClass('hidden');
					}

					$first_air_component = $($air_components[0]);
				}

				$component.find('.tp-simple-pricing').removeClass('hidden');

				$component.find('.tp-field').each(function iterator(i, tp_field) {
					var $tp_input = $(tp_field);

					if ($tp_input.data('price-row') !== 'price' && $tp_input.data('price-row') !== 'ncf' && $tp_input.data('price-row') !== 'commission') {
						_getCommissionField($tp_input).val('0.00');
						$tp_input.val('0.00');

						if ($tp_input.data('commissionable') === 'yes') {
							$tp_input.data('commission-percentage', $tp_input.data('default-commission-percentage'));
						}

						_copyPricingRow($tp_input);
					}
				});

				$component.find('[data-price-row="total_price"]').trigger('pricechanged');
			}
		});

		$('.tp-sp-field').on('pricechanged', function pricechanged(e) {
			var $input                    = $(this),
			    $component                = $('#' + $input.data('component-key')),
			    $traveler_prices          = $component.find('.tp-price-row-price'),
			    $traveler_ncfs            = $component.find('.tp-price-row-ncf'),
			    $traveler_commissions     = $component.find('.tp-price-row-commission'),
			    $traveler_air_prices      = null,
			    $traveler_air_commissions = null,
			    traveler_count            = $component.find('.tp-column-header').length,
			    total_price               = _fixFloat($component.find('[data-price-row="total_price"]').val()),
			    total_commission          = _fixFloat($component.find('[data-price-row="total_commission"]').val()),
			    commission_rate           = _fixFloat($component.find('[data-price-row="commission_rate"]').val()),
			    total_air_price           = 0.00,
			    air_commission_rate       = 0.00,
			    air_commission            = 0.00,
			    total_ncf                 = 0.00,
			    total                     = 0.00,
			    traveler_price,
			    traveler_ncf,
			    traveler_commission,
			    traveler_air_price,
			    traveler_air_commission;

			if ($first_air_component !== null) {
				$traveler_air_prices      = $first_air_component.find('.tp-price-row-price');
				$traveler_air_commissions = $first_air_component.find('.tp-price-row-commission');

				total_air_price     = _fixFloat($component.find('[data-price-row="total_air_price"]').val());
				air_commission_rate = _fixFloat($component.find('[data-price-row="air_commission_rate"]').val());
				air_commission      = total_air_price * (air_commission_rate / 100);

				total_price      -= total_air_price;
				total_commission -= air_commission;

				if (total_price < 0) {
					total_price = 0.00;
				}

				if (total_commission < 0) {
					total_commission = 0.00;
				}
			}

			if (total_price <= 0) {
				total_commission = 0.00;
			}

			if (total_commission > 0) {
				total_ncf = total_price - (total_commission / (commission_rate / 100));
			}

			if (total_ncf < 0) {
				total_ncf = 0.00;
			}

			traveler_price      = accounting.formatNumber(((total_price - total_ncf) / traveler_count), 2, '');
			traveler_ncf        = accounting.formatNumber((total_ncf / traveler_count), 2, '');
			traveler_commission = accounting.formatNumber((total_commission / traveler_count), 2, '');

			total_price -= total_ncf;

			$traveler_prices.each(function iterator(i, tp_field) {
				var $tp_input    = $(tp_field),
					$cp_checkbox;

				total += traveler_price;

				if (total > total_price) {
					traveler_price = accounting.formatNumber((traveler_price - (total - total_price)), 2, '');

					$cp_checkbox = $component.find('.tp-cp-price-column-' + $tp_input.data('price-column'));

					if ($cp_checkbox.is(':checked')) {
						$cp_checkbox.prop('checked', false);
					}
				}

				$tp_input.val(traveler_price);
			});

			if (total < total_price) {
				traveler_price = accounting.formatNumber((traveler_price + (total_price - total)), 2, '');

				$($traveler_prices[0]).val(traveler_price);

				$component.find('.tp-copy-pricing').prop('checked', false);
			}

			$traveler_prices.trigger('pricechanged');

			total = 0.00;

			$traveler_ncfs.each(function iterator(i, tp_field) {
				var $tp_input    = $(tp_field),
					$cp_checkbox;

				total += traveler_ncf;

				if (total > total_ncf) {
					traveler_ncf = accounting.formatNumber((traveler_ncf - (total - total_ncf)), 2, '');

					$cp_checkbox = $component.find('.tp-cp-price-column-' + $tp_input.data('price-column'));

					if ($cp_checkbox.is(':checked')) {
						$cp_checkbox.prop('checked', false);
					}
				}

				$tp_input.val(traveler_ncf);
			});

			if (total < total_ncf) {
				traveler_ncf = accounting.formatNumber((_fixFloat(traveler_ncf) + (total_ncf - total)), 2, '');

				$($traveler_ncfs[0]).val(traveler_ncf);

				$component.find('.tp-copy-pricing').prop('checked', false);
			}

			$traveler_ncfs.trigger('pricechanged');

			total = 0.00;

			$traveler_commissions.each(function iterator(i, tp_field) {
				var $tp_input       = $(tp_field),
					$tp_price_input = $($traveler_prices[i]),
					$cp_checkbox;

				total += traveler_commission;

				if (total > total_commission) {
					traveler_commission = accounting.formatNumber((traveler_commission - (total - total_commission)), 2, '');

					$cp_checkbox = $component.find('.tp-cp-price-column-' + $tp_input.data('price-column'));

					if ($cp_checkbox.is(':checked')) {
						$cp_checkbox.prop('checked', false);
					}
				}

				$tp_input.val(traveler_commission);

				$tp_price_input.data('commission-percentage', commission_rate);
				_getCommissionField($tp_price_input).val(traveler_commission);
			});

			if (total < total_commission) {
				traveler_commission = accounting.formatNumber((traveler_commission + (total_commission - total)), 2, '');

				$($traveler_commissions[0]).val(traveler_commission);

				$($traveler_prices[0]).data('commission-percentage', commission_rate);
				_getCommissionField($($traveler_prices[0])).val(traveler_commission);

				$component.find('.tp-copy-pricing').prop('checked', false);
			}

			$traveler_commissions.trigger('pricechanged');

			if (total_air_price > 0) {
				traveler_air_price      = accounting.formatNumber((total_air_price / traveler_count), 2, '');
				traveler_air_commission = accounting.formatNumber((air_commission / traveler_count), 2, '');

				if ($first_air_component.find('.tp-cc-button-price[value="1"]').length > 0) {
					$first_air_component.find('.tp-cc-button-price[value="1"]').trigger('click');
				}

				total = 0.00;

				$traveler_air_prices.each(function iterator(i, tp_field) {
					var $tp_input    = $(tp_field),
						$cp_checkbox;

					total += traveler_air_price;

					if (total > total_air_price) {
						traveler_price = accounting.formatNumber((traveler_air_price - (total - total_air_price)), 2, '');

						$cp_checkbox = $component.find('.tp-cp-price-column-' + $tp_input.data('price-column'));

						if ($cp_checkbox.is(':checked')) {
							$cp_checkbox.prop('checked', false);
						}
					}

					$tp_input.val(traveler_air_price);
				});

				if (total < total_air_price) {
					traveler_air_price = accounting.formatNumber((traveler_air_price + (total_air_price - total)), 2, '');

					$($traveler_air_prices[0]).val(traveler_air_price);

					$component.find('.tp-copy-pricing').prop('checked', false);
				}

				$traveler_air_prices.trigger('pricechanged');

				total = 0.00;

				$traveler_air_commissions.each(function iterator(i, tp_field) {
					var $tp_input       = $(tp_field),
						$tp_price_input = $($traveler_air_prices[i]),
						$cp_checkbox;

					total += traveler_air_commission;

					if (total > air_commission) {
						traveler_air_commission = accounting.formatNumber((traveler_air_commission - (total - air_commission)), 2, '');

						$cp_checkbox = $component.find('.tp-cp-price-column-' + $tp_input.data('price-column'));

						if ($cp_checkbox.is(':checked')) {
							$cp_checkbox.prop('checked', false);
						}
					}

					$tp_input.val(traveler_air_commission);

					$tp_price_input.data('commission-percentage', air_commission_rate);
					_getCommissionField($tp_price_input).val(traveler_air_commission);
				});

				if (total < air_commission) {
					traveler_air_commission = accounting.formatNumber((traveler_air_commission + (air_commission - total)), 2, '');

					$($traveler_air_commissions[0]).val(traveler_air_commission);

					$($traveler_air_prices[0]).data('commission-percentage', air_commission_rate);
					_getCommissionField($($traveler_air_prices[0])).val(traveler_air_commission);

					$component.find('.tp-copy-pricing').prop('checked', false);
				}

				$traveler_air_commissions.trigger('pricechanged');
			} else if ($first_air_component !== null) {
				if ($first_air_component.find('.tp-cc-button-price[value="0"]').length > 0) {
					$first_air_component.find('.tp-cc-button-price[value="0"]').data('skip-confirm', true);
					$first_air_component.find('.tp-cc-button-price[value="0"]').trigger('click');
				}

				$traveler_air_prices.each(function iterator(i, tp_field) {
					$(tp_field).val('0.00');
				});

				$traveler_air_prices.trigger('pricechanged');
			}
		});

		$('.tp-sp-includes-air-button').on('change', function change (e) {
			var $radio               = $(this),
			    $component           = $('#' + $radio.data('component-key')),
			    $air_commission_rate;

			if ($radio.val() === '1') {
				$component.find('.tp-sp-total-air-price').removeClass('hidden');
				$component.find('.tp-sp-air-commission-rate').removeClass('hidden');
			} else {
				$component.find('.tp-sp-total-air-price').addClass('hidden');
				$component.find('.tp-sp-air-commission-rate').addClass('hidden');

				$component.find('[data-price-row="total_air_price"]').val('0.00');

				$air_commission_rate = $component.find('[data-price-row="air_commission_rate"]');

				$air_commission_rate.val('5.00');
				$air_commission_rate.trigger('pricechanged');
			}
		});

		$('.tp-field').on('focus', function focus(e) {
			var $input  = $(this),
			    $cc_row;

			$('.commission_calculator').addClass('hidden');
			$('.tp-conditionally-commissionable').addClass('hidden');

			if ($input.data('pricing-type') === 'charge') {
				if ($input.data('conditionally-commissionable') === 1) {
					$cc_row = $('#' + $input.data('component-key')).find('.tp-cc-price-row-' + $input.data('price-row'));

					$cc_row.data('last-focused-tp-field', $input);
					$cc_row.removeClass('hidden');
				}

				if (
					$input.data('commissionable') === 'yes'
					&& !$('#' + $input.data('component-key')).find('[data-pricing-type=commission][data-commission-type=' + $input.data('commission-type') + ']').hasClass('tp-econnect-locked')
				) {
					_updateCalculator($input);

					$('.commission_calculator').removeClass('hidden');
				}
			}

			_copyPricingRow($(this));
		});

		$('.tp-field').on('pricechanged', function pricechanged(e) {
			var $input        = $(this),
			    $coupon_input;

			if ($input.val().substr(0, 1) === '-') {
				$input.val($input.val().substr(1));
			}

			if ($input.data('pricing-type') === 'charge') {
				if ($input.data('commissionable') === 'yes') {
					_calculateCommission($input);

					if (typeof code_triggered === 'undefined') {
						_updateCalculator($input);
					}
				}
			}

			if ($input.data('special-type') === 'coupon') {
				$coupon_input = $('#' + $input.data('component-key')).find('.tp-price-row-price.tp-price-column-' + $input.data('price-column'));

				$coupon_input.trigger('pricechanged');
			}

			_copyPricingRow($input);
			_updateTotals();
		});

		$('.tp-field').on('blur', function blur(e) {
			var $input     = $(this),
			    $component = $('#' + $input.data('component-key'));

			if ($input.data('special-type') === 'gateway') {
				return;
			}

			$component.find('.tp-price-row-' + $input.data('price-row')).each(function iterator(i, tp_field) {
				var $tp_input = $(tp_field);

				$tp_input.val(accounting.formatNumber($tp_input.val(), 2, ''));
			});
		});

		$('.tp-price-row-gateway').on('keyup', function change(e) {
			_copyPricingRow($(this));
		});

		$('.tp-copy-pricing').on('change', function change(e) {
			var $checkbox = $(this);

			_copyPricingColumn($checkbox);

			$('.commission_calculator').addClass('hidden');
			$('.tp-conditionally-commissionable').addClass('hidden');

			_updateTotals();
		});

		$(document).on('click', '.remove-amenity', function change(e) {
			var $amenity_templates = $('.tp-amenity-templates'),
			reservation_id         = $(this).data('reservation-id'),
			applied_amenities      = $('.applied_amenities'),
			travel_amenities       = $('.travel-amenities'),
			component_amenity      = $(this).data('component-amenity');
			
			e.preventDefault(); 

			Adzuki.CustomConfirm({
				title  : 'Decision Time',
				content: 'Are you sure you wish to delete amenities tied to the selected Amenity Template?',
				confirm: function confirm() {
					Adzuki.Ajax.get('/Reservations/removeTravelAmenities/' + reservation_id + '/' + component_amenity)
					.then(function removeTravelAmenities(response) {
						var json  = '',
						is_json   = true;

						console.log(response);

						json = JSON.parse(JSON.stringify(response));
						
						if (typeof json !== 'object') {
							// If parsing fails, it's not valid JSON
							is_json = false;
						}

						if (is_json) {
							if (response.error) {
								Adzuki.StatusMessage('Error', response.error);
							} else {
								$amenity_templates.addClass('hidden');

								applied_amenities.val(response.amenities);

								// $('.applied_amenities').val('0');

								travel_amenities.addClass('hidden');

								$('.amenities-alert p span').text(' you will be directed to the "Add Amenity/Onboard Credit" screen after clicking "Save and Continue" below.');
								
								Adzuki.StatusMessage('success', 'Your Amenity/Onboard credit has been deleted.');
							}
						} else {
							travel_amenities.html(response);

							Adzuki.StatusMessage('success', 'Your Amenity/Onboard credit has been deleted.');
						}
					});
				}
			});
		});

		$('.add-amenities').on('change', function change(e) {
			var $amenity_templates = $('.tp-amenity-templates'),
			add_amenities          = $(this).val(),
			reservation_id         = $(this).data('reservation-id'),
			applied_amenities      = $('.applied_amenities'),
			travel_amenities       = $('.travel-amenities'),
			button_amenities       = $('.btn-amenities'),
			amenity_count          = applied_amenities.val();

			if (add_amenities === '1') {
				// Yes
				if ($amenity_templates.hasClass('hidden') && button_amenities.length) {
					$amenity_templates.removeClass('hidden');
					$('.amenities-alert p span').text(' you will be directed to the "Add Amenity/Onboard Credit" screen after clicking "Save and Continue" below.');
				}
			} else {
				// No
				if (!$amenity_templates.hasClass('hidden')) {
					$amenity_templates.addClass('hidden');
				}

				$('.amenities-alert p span').text(' you will be directed to the "Add Amenity/Onboard Credit" screen after clicking "Save and Continue" below.');

				if (add_amenities === '0' && amenity_count === '1') {
					Adzuki.CustomConfirm({
						title  : 'Decision Time',
						content: 'Are you sure you wish to delete amenities tied to the selected Amenity Template?',
						confirm: function confirm() {
							Adzuki.Ajax.get('/Reservations/removeTravelAmenities/' + reservation_id )
							.then(function removeTravelAmenities(response) {
								var json  = '',
								is_json   = true;

								console.log(response);

								json = JSON.parse(JSON.stringify(response));
								
								if (typeof json !== 'object') {
									// If parsing fails, it's not valid JSON
									is_json = false;
								}

								if (is_json) {
									if (response.error) {
										Adzuki.StatusMessage('Error', response.error);
									} else {
										applied_amenities.val(response.amenities);

										travel_amenities.addClass('hidden');

										Adzuki.StatusMessage('success', 'Your Amenity/Onboard credit has been deleted.');
									}
								} else {
									travel_amenities.html(response);
									travel_amenities.addClass('hidden');

									applied_amenities.val('0');

									Adzuki.StatusMessage('success', 'Your Amenity Template has been deleted from this reservation.');
								}
							});
						}
					});
				}
			}
		});

		$('.amenity_template').on('click', function updateAlert(e) {
			var $template_id            = $(this).data('template-id'),
				$registration_vendor_id = $(this).data('vendor-id'),
				$reservation_id         = $(this).data('reservation-id'),
				applied_amenities       = $('.applied_amenities'),
				travel_amenities        = $('.travel-amenities'),
				json                    = '',
				is_json                 = true;

			e.preventDefault(); 

			$('.amenity-form-loader').removeClass('hidden');

			$('#reservationtravelpricing-apply_amenities').val($template_id);

			Adzuki.Ajax.get('/Reservations/addTravelAmenity/' + $template_id + '/' + $registration_vendor_id + '/' + $reservation_id)
			.then(function getAddedAmenities(response) {
				json = JSON.parse(JSON.stringify(response));
				
				if (typeof json !== 'object') {
					// If parsing fails, it's not valid JSON
					is_json = false;
				}

				if (is_json) {
					Adzuki.StatusMessage('Error', response.error);
					$('.amenity-form-loader').addClass('hidden');
				} else {
					travel_amenities.html(response);
					travel_amenities.removeClass('hidden');

					$('.amenities-alert p span').text(' all amenities/onboard credits within the Amenity Template selected have been added to this reservation. You may delete certain amenities/onboard credits from this section that you do not want to include for this reservation, and you may manage the amenities/onboard credits from the designated Reservation Section at any time once saved.');

					Adzuki.StatusMessage('success', 'Your Amenity Template has been added successfully.');

					applied_amenities.val('1');
					$('.amenity-form-loader').addClass('hidden');
				}
			});
		});

		$('.tp-cc-button').on('change', function change(e) {
			var $radio      = $(this),
			    $component  = $('#' + $radio.data('component-key')),
			    $icon       = $component.find('.tp-comm-icon-' + $radio.data('price-row')),
			    $cc_row     = $component.find('.tp-cc-price-row-' + $radio.data('price-row')),
			    $tp_fields  = $component.find('.tp-price-row-' + $radio.data('price-row')),
			    $yes_radio,
			    yes_confirm;

			if ($radio.val() === '1') {
				$radio.parent().prev().removeClass('active');
				$radio.parent().addClass('active');

				$icon.removeClass('text-muted');
				$icon.addClass('icon-green');

				$tp_fields.each(function iterator(i, tp_field) {
					var $tp_input = $(tp_field);

					$tp_input.addClass('commissionable');
					$tp_input.data('commissionable', 'yes');
					_getCommissionableField($tp_input).val('1');

					_calculateCommission($tp_input);
				});

				setTimeout(function timeout() {
					if (typeof $cc_row.data('last-focused-tp-field') === 'undefined') {
						$($tp_fields[0]).trigger('focus');
					} else {
						$cc_row.data('last-focused-tp-field').trigger('focus');
					}
				}, 0);
			} else {
				$radio.parent().removeClass('active');

				$yes_radio = $radio.parent().next().children().first();
				$yes_radio.prop('checked', true);
				$yes_radio.parent().addClass('active');

				yes_confirm = function yes_confirm() {
					$yes_radio.parent().removeClass('active');

					$radio.prop('checked', true);
					$radio.parent().addClass('active');

					$icon.removeClass('icon-green');
					$icon.addClass('text-muted');

					$tp_fields.each(function iterator(i, tp_field) {
						var $tp_input = $(tp_field);

						$tp_input.removeClass('commissionable');
						$tp_input.data('commissionable', 'no');
						$tp_input.data('commission-percentage', $tp_input.data('default-commission-percentage'));
						_getCommissionableField($tp_input).val('0');

						_calculateCommission($tp_input);
					});

					$('.commission_calculator').addClass('hidden');
				};

				if (typeof $radio.data('skip-confirm') === 'undefined') {
					Adzuki.CustomConfirm({
						body   : 'Setting this to "No" will clear out all commission for this charge. Do you want to continue?',
						confirm: yes_confirm
					});
				} else {
					yes_confirm();

					$radio.removeData('skip-confirm');
				}
			}

			_updateTotals();
		});

		$('.tp-component-header').on('click', function change(e) {
			var $header = $(this),
			    $toggle = $header.find('.toggle-form-control');

			if ($toggle.hasClass('minus')) {
				_toggleComponent($header, 'collapse');
			} else {
				_toggleComponent($header, 'expand');
			}
		});

		$('.tp-commission-field').each(function iterator(i, tp_field) {
			_toggleCommissionField($(tp_field));
		});

		_updateTotals();

		$('.tp-component-header').each(function iterator(i, header) {
			var $header = $(header);

			if ($header.data('has-pricing') === 1) {
				_toggleComponent($(header), 'expand');
			}
		});

		if ($('.tp-pricing-display-type').length > 0) {
			$('.tp-pricing-display-type[value="simple"]').trigger('click');
		} else {
			$('.tp-expand-collapse-div').removeClass('hidden');
		}

		$('.tp-all-pricing').removeClass('hidden');

		$(window).on('resize', function resize(e) {
			var $commission_calculator = $('.commission_calculator');

			$commission_calculator.width($commission_calculator.parent().width());
		});

		// changes on alert message when toggling the yes/no fields
		if (
			$('.post-payments').length > 0
			&& $('.add-amenities').length > 0
		) {
			$('.post-payments').on('change', _updateRadioAlerts);
			$('.add-amenities').on('change', _updateRadioAlerts);
		}
	};

	form.success = function success(response)
	{
		var $add_vendor_submit = $('.add-vendor-submit');

		if (!Adzuki.Form.hasError(response)) {
			window.location.href = response['data'];
			return true;
		}

		if (response['status'] === 'validation_error') {
			$.each(response['data'], function iterator(i, error_data) {
				if ('errors' in error_data && error_data['errors'][0].substr(0, 20) === 'Selected Travelers ') {
					$('.selected-travelers-box').addClass('selected-travelers-error');

					return false;
				}
			});
		}

		$add_vendor_submit.next().css('visibility', 'hidden');
		$add_vendor_submit.removeClass('disabled');

		return false;
	};

	_applyCoupon = function _applyCoupon($input)
	{
		var $coupon_tp_field = $('#' + $input.data('component-key')).find('.tp-price-row-coupon.tp-price-column-' + $input.data('price-column')),
		    amount           = _fixFloat($input.val());

		if (
			$coupon_tp_field.length > 0
			&& (
				$coupon_tp_field.data('special-type-action') === 'sub_comm' ||
				$coupon_tp_field.data('special-type-action') === 'sub_total_comm'
			)
		) {
			amount -= _fixFloat($coupon_tp_field.val());

			if (amount < 0) {
				amount = 0;
			}
		}

		return amount;
	};

	_calculateCommission = function _calculateCommission($input)
	{
		var $component     = $('#' + $input.data('component-key')),
		    commissionable = _fixFloat($input.val()),
		    commissions    = {};

		if ($input.data('commissionable') === 'yes') {
			if ($input.data('price-row') === 'price') {
				commissionable = _applyCoupon($input);
			}

			_getCommissionField($input).val(accounting.formatNumber((commissionable * (_fixFloat($input.data('commission-percentage')) / 100)), 2, ''));
		} else {
			_getCommissionField($input).val('0.00');
		}

		$component.find('.tp-price-column-' + $input.data('price-column')).each(function iterator(i, tp_field) {
			var $tp_input = $(tp_field);

			if ($tp_input.data('pricing-type') === 'charge') {
				if ($tp_input.data('commissionable') === 'yes') { // || $tp_input.data('special-type') === 'markup') { REMOVED THIS AS PER PHILL
					if (!($tp_input.data('commission-type') in commissions)) {
						commissions[$tp_input.data('commission-type')] = 0;
					}

					if ($tp_input.data('commissionable') === 'yes') {
						commissions[$tp_input.data('commission-type')] += _fixFloat(_getCommissionField($tp_input).val());
					} else {
						commissions[$tp_input.data('commission-type')] += _fixFloat($tp_input.val());
					}
				} else if ($tp_input.data('conditionally-commissionable') === 1) {
					if (!($tp_input.data('commission-type') in commissions)) {
						commissions[$tp_input.data('commission-type')] = 0;
					}
				}
			} else if ($tp_input.data('pricing-type') === 'commission' && $tp_input.data('commission-type') in commissions) {
				if ($component.find('.tp-pricing-display-type').length === 0 || $component.find('.tp-pricing-display-type:checked').val() === 'detailed') {
					_showCommissionChange($tp_input, commissions[$tp_input.data('commission-type')]);
				}

				$tp_input.val(accounting.formatNumber(commissions[$tp_input.data('commission-type')], 2, ''));

				_toggleCommissionField($tp_input);

				_copyPricingRow($tp_input);
			}
		});
	};

	_calculatePercentage = function _calculatePercentage(price, commission)
	{
		return accounting.formatNumber(((_fixFloat(commission) / _fixFloat(price)) * 100), 2, '');
	};

	_copyPricingColumn = function _copyPricingColumn($checkbox)
	{
		var $component        = $('#' + $checkbox.data('component-key')),
		    prev_price_column,
		    $prev_input;

		if ($checkbox.is(':checked')) {
			prev_price_column = ($checkbox.data('price-column') - 1);

			$component.find('.tp-price-column-' + $checkbox.data('price-column') + ':not(".tp-econnect-locked")').each(function iterator(i, tp_field) {
				var $input     = $(tp_field),
				    $tp_fields = $component.find('.tp-price-row-' + $input.data('price-row'));

				$prev_input = $($tp_fields[prev_price_column]);

				_getCommissionField($input).val(_getCommissionField($prev_input).val());
				$input.data('commission-percentage', $prev_input.data('commission-percentage'));
				$input.val($prev_input.val());

				if ($input.data('pricing-type') === 'commission') {
					_toggleCommissionField($input);
				}

				_copyPricingRow($input);
			});

			$component.find('.tp-gateway-column-' + $checkbox.data('price-column')).each(function iterator(i, tp_field) {
				var $input     = $(tp_field),
				    $tp_fields = $component.find('.tp-price-row-' + $input.data('price-row'));

				$prev_input = $($tp_fields[prev_price_column]);

				$input.val($prev_input.val());

				_copyPricingRow($(tp_field));
			});
		} else {
			Adzuki.CustomConfirm({
				body   : 'Do you want to clear out this traveler\'s pricing?',
				confirm: function yes() {
					$component.find('.tp-price-column-' + $checkbox.data('price-column') + ':not(".tp-econnect-locked")').each(function iterator(i, tp_field) {
						var $tp_input = $(tp_field);

						_getCommissionField($tp_input).val('0.00');
						$tp_input.val('0.00');

						if ($tp_input.data('commissionable') === 'yes') {
							$tp_input.data('commission-percentage', $tp_input.data('default-commission-percentage'));
						}

						if ($tp_input.data('pricing-type') === 'commission') {
							_toggleCommissionField($tp_input);
						}

						_copyPricingRow($tp_input);
						_updateTotals();
					});

					$component.find('.tp-gateway-column-' + $checkbox.data('price-column')).each(function iterator(i, tp_field) {
						var $tp_input = $(tp_field);

						$tp_input.val('');

						_copyPricingRow($tp_input);
					});
				}
			});
		}
	};

	_copyPricingRow = function _copyPricingRow($input)
	{
		var $component        = $('#' + $input.data('component-key')),
		    $tp_fields        = $component.find('.tp-price-row-' + $input.data('price-row')),
		    next_price_column = ($input.data('price-column') + 1),
		    $next_input,
		    $copy_pricing;

		if ($tp_fields.length > next_price_column) {
			$copy_pricing = $component.find('.tp-cp-price-column-' + next_price_column);

			if ($copy_pricing.length > 0 && $copy_pricing.is(':checked')) {
				$next_input = $($tp_fields[next_price_column]);

				// if field is disabled, we should not copy
				if (!$input.hasClass('disabled')) {
					$next_input.val($input.val());
				}

				if ($input.data('special-type') !== 'gateway') {
					_getCommissionField($next_input).val(_getCommissionField($input).val());
					$next_input.data('commissionable', $input.data('commissionable'));
					$next_input.data('commission-percentage', $input.data('commission-percentage'));

					if ($next_input.data('pricing-type') === 'commission') {
						_toggleCommissionField($next_input);
					}
				}

				_copyPricingRow($next_input);
			}
		}
	};

	_fixFloat = function _fixFloat(float)
	{
		var fixed_float = parseFloat(float);

		if (isNaN(fixed_float)) {
			return parseFloat(0);
		}

		return fixed_float;
	};

	_formatTotal = function _formatTotal(total)
	{
		if (_fixFloat(total) >= 0) {
			return accounting.formatMoney(total);
		}

		return '<span class="negative-number">(' + accounting.formatMoney(Math.abs(total)) + ')</span>';
	};

	_getCommissionField = function _getCommissionField($input)
	{
		return $input.parent().nextAll('.tp-hidden-commission-field');
	};

	_getCommissionableField = function _getCommissionableField($input)
	{
		return $input.parent().nextAll('.tp-hidden-commissionable-field');
	};

	_showCommissionChange = function _showCommissionChange($input, new_value)
	{
		if (_fixFloat(new_value) === _fixFloat($input.val())) {
			return;
		}

		clearTimeout(commission_change_timeout);

		if (old_commission === null) {
			old_commission = $input.val();
		}

		if (_fixFloat(new_value) !== _fixFloat(old_commission)) {
			commission_change_timeout = setTimeout(function timeout() {
				var $component = $('#' + $input.data('component-key')),
				    message    = $input.data('price-title') + ' commission ',
				    traveler   = $component.find('.tp-t-column-' + $input.data('price-column'));

				if (traveler.length > 0) {
					message += 'for ' + traveler.html() + ' ';
				}

				message += 'changed from <b>' + accounting.formatMoney(old_commission) + '</b> to <b>' + accounting.formatMoney(new_value) + '</b>.';

				toastr.info(
					message,
					null,
					{
						positionClass  : 'toast-top-center',
						timeOut        : 5000,
						extendedTimeOut: 0,
					}
				);

				old_commission = null;
			}, 500);
		}
	};

	_toggleCommissionField = function _toggleCommissionField($input)
	{
		var $component,
		    commissionable;

		if ($input.data('commission-type') !== 'package' && $input.data('commission-type') !== 'bonus') {
			$component     = $('#' + $input.data('component-key'));
			commissionable = 0;

			$component.find('.tp-price-column-' + $input.data('price-column')).each(function iterator(i, tp_field) {
				var $tp_input = $(tp_field);

				if (
					$tp_input.data('pricing-type') === 'charge'
					&& $tp_input.data('commissionable') === 'yes'
					&& $tp_input.data('commission-type') === $input.data('commission-type')
				) {
					commissionable += _fixFloat($tp_input.val());
				}
			});

			// if intended to be econnect locked, do not toggle readonly or disabled, etc
			if ($input.hasClass('tp-econnect-locked')) {
				return;
			}

			if (commissionable > 0) {
				$input.data('title', '');
				$input.tooltip('destroy');
				$input.prop('readonly', false);
				$input.removeClass('disabled');
			} else {
				$input.addClass('disabled');
				$input.prop('readonly', true);
				$input.data('title', 'One or more base commissionable fields must have a value greater than zero in order to enter base commission.');
				$input.tooltip();
			}
		}
	};

	_toggleComponent = function _toggleComponent($header, action)
	{
		var $toggle = $header.find('.toggle-form-control');

		if (action === 'collapse') {
			$header.next().addClass('hidden');
			$toggle.removeClass('minus');
			$toggle.addClass('plus');

			$header.find('.tp-column-header').addClass('hidden');
		} else {
			$header.next().removeClass('hidden');
			$toggle.removeClass('plus');
			$toggle.addClass('minus');

			$header.find('.tp-column-header').removeClass('hidden');
		}
	};

	_updateCalculator = function _updateCalculator($input)
	{
		var commission            = _fixFloat(_getCommissionField($input).val()),
		    commission_percentage = _fixFloat($input.data('commission-percentage')),
		    price                 = $input.val();

		$('.commission_calculator').data('current-input', $input);

		$('#cc-price-title').html($input.data('price-title'));

		if (price === '') {
			price = 0;
		} else if ($input.data('price-row') === 'price') {
			price = _applyCoupon($input);
		}

		$('#cc-price').html(accounting.formatMoney(price));

		if (commission === 0) {
			commission = (commission_percentage / 100) * _fixFloat($input.val());
		}

		$('#cc-commission').html(accounting.formatMoney(commission));
		$('#cc-commission-percentage').val(accounting.formatNumber(commission_percentage, 2, ''));
		$('#cc-new-commission').val('');

		$('#cc-new-commission').prop('disabled', true);
		$('#cc-accept-button').prop('disabled', true);
	};

	_updateRadioAlerts = function _updateRadioAlerts(e)
	{
		var payments_checked  = $('#reservationtravelpricing-post_payments-0').is(':checked');
		var amenities_checked = $('#reservationtravelpricing-add_amenities-0').is(':checked');

		if (payments_checked && amenities_checked) {
			// update wording since both things are checked
			$('.amenities-alert').find('span')
				.first().html('you will be directed to the "Add Amenity/Onboard Credit" screen first after clicking "Save and Continue" below.');

			$('.payment-alert').find('span')
				.first().html('you will be directed to the "Post Payment" screen once your amenities/onboard credits are entered on the previous screen after clicking "Save and Continue" below.');
			return;
		}

		// update wording back to normal, since one of them has been unchecked
		$('.amenities-alert').find('span')
			.first().html('you will be directed to the "Add Amenity/Onboard Credit" screen after clicking "Save and Continue" below.');

		$('.payment-alert').find('span')
			.first().html('you will be directed to the "Post Payment" screen after clicking "Save and Continue" below.');
	};

	_updateTotals = function _updateTotals()
	{
		var charge_grand_total     = 0,
		    commission_grand_total = 0;

		$('.tp-total-row').addClass('hidden');
		$('.tp-total').html('$0.00');

		$('.tp-traveler-total').each(function iterator(i, traveler) {
			var price_column     = $(traveler).data('price-column'),
				charges          = {},
				commissions      = {},
				charge_total     = 0,
				commission_total = 0;

			$('.tp-price-column-' + price_column).each(function iterator(j, tp_field) {
				var $tp_input = $(tp_field);

				switch ($tp_input.data('pricing-type')) {
					case 'credit':
						if (!($tp_input.data('actual-type') in charges)) {
							charges[$tp_input.data('actual-type')] = 0;
						}

						charges[$tp_input.data('actual-type')] -= _fixFloat($tp_input.val());

						if ($tp_input.data('special-type') === 'discount') {
							if (!($tp_input.data('actual-type') in commissions)) {
								commissions[$tp_input.data('actual-type')] = 0;
							}

							commissions[$tp_input.data('actual-type')] -= _fixFloat($tp_input.val());
						}
						break;
					case 'commission':
						if (!($tp_input.data('actual-type') in commissions)) {
							commissions[$tp_input.data('actual-type')] = 0;
						}

						commissions[$tp_input.data('actual-type')] += _fixFloat($tp_input.val());
						break;
					default: // charge
						if (!($tp_input.data('actual-type') in charges)) {
							charges[$tp_input.data('actual-type')] = 0;
						}

						charges[$tp_input.data('actual-type')] += _fixFloat($tp_input.val());

						if ($tp_input.data('special-type') === 'additional' || $tp_input.data('special-type') === 'markup') {
							if (!($tp_input.data('actual-type') in commissions)) {
								commissions[$tp_input.data('actual-type')] = 0;
							}

							commissions[$tp_input.data('actual-type')] += _fixFloat($tp_input.val());
						}
						break;
				}
			});

			$.each(charges, function iterator(component_type, charge) {
				if (charge !== 0) {
					$('.tp-cht-row-' + component_type).removeClass('hidden');
					$('.tp-cot-row-' + component_type).removeClass('hidden');

					$('.tp-cht-' + component_type + '-' + price_column).html(_formatTotal(charge));

					charge_total += charge;
				}
			});

			$('.tp-cht-total-' + price_column).html(_formatTotal(charge_total));

			charge_grand_total += charge_total;

			$.each(commissions, function iterator(component_type, commission) {
				if (commission !== 0) {
					$('.tp-cht-row-' + component_type).removeClass('hidden');
					$('.tp-cot-row-' + component_type).removeClass('hidden');

					$('.tp-cot-' + component_type + '-' + price_column).html(_formatTotal(commission));

					commission_total += commission;
				}
			});

			$('.tp-cot-total-' + price_column).html(_formatTotal(commission_total));

			commission_grand_total += commission_total;
		});

		$('.tp-cht-total').html(_formatTotal(charge_grand_total));
		$('.tp-cot-total').html(_formatTotal(commission_grand_total));
	};

}(jQuery, window.Adzuki || {}));
